import Flex from 'components/Flex'
import Page from 'modules/Page/Container/index'
import React, { useEffect, useState } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import { authenticated } from 'routes/config/user'
import styled from 'styled-components'
import { PermittedNavRoutes } from '../../utils/permissionsValidation'
const { AUTH_URL } = process.env

const PageFlex = styled(Flex)`
  overflow: hidden;
  // margin-top: -25px !important;
`
const AuthPage = ({ isAuthenticated, permissions }) => {
  const navigate = useNavigate()
  const [isIdle, setIsIdle] = useState(false)

  useEffect(() => {
    let idleTimer

    const resetTimer = () => {
      clearTimeout(idleTimer)
      idleTimer = setTimeout(() => setIsIdle(true), 900000)
    }

    const onActivity = () => {
      setIsIdle(false)
      resetTimer()
    }

    resetTimer()

    window.addEventListener('mousemove', onActivity)
    window.addEventListener('keydown', onActivity)
    window.addEventListener('scroll', onActivity)

    return () => {
      clearTimeout(idleTimer)
      window.removeEventListener('mousemove', onActivity)
      window.removeEventListener('keydown', onActivity)
      window.removeEventListener('scroll', onActivity)
    }
  }, [])

  useEffect(() => {
    if (isIdle) {
      window.location.href = AUTH_URL
      window.location.replace(AUTH_URL)
    }
  }, [isIdle])
  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/signin')
    }
  }, [isAuthenticated])

  const permittedRoutes = PermittedNavRoutes(permissions, authenticated)

  return (
    <PageFlex>
      {isAuthenticated && (
        <Page>
          <Routes>
            {permittedRoutes.map(({ routePath, Component }) => {
              return (
                <Route
                  key={routePath}
                  path={routePath}
                  element={<Component />}
                ></Route>
              )
            })}
          </Routes>
        </Page>
      )}
    </PageFlex>
  )
}

export default AuthPage
